import React, { useEffect, useState } from 'react';
import Icon, { IconColor } from '../icon/icon';
import { qaAttribute } from '../utils/qa-service';
import { hintTooltipCss } from './hint-tooltip.style';

type Theme = 'base' | 'blue' | 'white';
type TooltipType = 'GT' | 'Bark';

const HintTooltip = ({
    content,
    triggerColor = 'newGrey',
    closeBtnColor,
    theme = 'base',
    elName,
    hasCloseBtn = true,
    hintDirection = 'bottom',
    align = 'center',
    size = 'default',
    type = 'GT',
}: {
    content: string | React.ReactNode;
    triggerColor: IconColor;
    closeBtnColor: IconColor;
    theme?: Theme;
    hintDirection?: 'bottom' | 'top';
    elName: string;
    hasCloseBtn?: boolean;
    align?: 'left' | 'right' | 'center';
    size?: 'default' | 'large' | 'small';
    type?: TooltipType;
}) => {
    const [openContent, setOpenContent] = useState(false);

    const closeContent = (e) => {
        const isClickingTrigger = e.target.id === `${elName}-tooltip-trigger`;
        const isClickingContent = e.target.id === `${elName}-tooltip-content`;

        if (!(isClickingTrigger || isClickingContent)) {
            setOpenContent(false);
        }
    };

    useEffect(() => {
        if (openContent) {
            document.addEventListener('click', closeContent);
        } else {
            document.removeEventListener('click', closeContent);
        }
        return () => document.removeEventListener('click', closeContent);
    }, [openContent]);

    return (
        <div
            className={`hint-tooltip hint-tooltip--color-${theme}`}
            {...qaAttribute(`${elName}-tooltip`)}
            css={hintTooltipCss({ type, wider: typeof content === 'string' && content.length > 65 })}
        >
            <Icon
                className={`hint-tooltip-trigger hint-tooltip-trigger--${size}`}
                id={`${elName}-tooltip-trigger`}
                color={triggerColor}
                type="info-outline"
                onClick={(event) => {
                    event.stopPropagation();
                    setOpenContent(!openContent);
                }}
                {...qaAttribute(`${elName}-tooltip-trigger`)}
            />
            {openContent && (
                <div
                    className={`hint-tooltip-content hint-tooltip-content--${align} hint-tooltip-direction--${hintDirection} hint-tooltip-content--${
                        hasCloseBtn ? 'has-close-btn' : 'without-close-btn'
                    }`}
                    id={`${elName}-tooltip-content`}
                    {...qaAttribute(`${elName}-tooltip-content`)}
                >
                    {content}
                    {hasCloseBtn && (
                        <Icon
                            className="hint-tooltip-close-btn"
                            color={closeBtnColor}
                            size="smallest"
                            type="clear"
                            onClick={() => setOpenContent(false)}
                            {...qaAttribute(`${elName}-tooltip-close-btn`)}
                        />
                    )}
                </div>
            )}
        </div>
    );
};

export default HintTooltip;
